import EntityConstants from "../configs/EntityConstants";
import { GET } from "../service/CRUDService";
import { isPostIssuanceVerificationEnabledFromPermissions } from "./userPermissions";

export const fetchCurrentUser = async () => {
  try {
    const response = await GET(EntityConstants.CURRENT_USER);
    if (!response.ok) {
      throw new Error(`Failed to fetch current user: ${response.status}`);
    }
    const data = await response.json();

    try {
      const permissionsResponse = await GET(
        EntityConstants.CURRENT_USER_PERMISSIONS,
      );

      if (permissionsResponse.ok) {
        const permissionsData = await permissionsResponse.json();
        return {
          ...data,
          sidebar_components: permissionsData.sidebar_components || [],
          is_transfer_enabled: permissionsData.is_transfer_enabled === true,
          is_post_issuance_verification_enabled:
            isPostIssuanceVerificationEnabledFromPermissions(permissionsData),
          is_white_label_enabled:
            permissionsData.is_white_label_enabled === true,
          is_html_designs_enabled:
            permissionsData.is_html_designs_enabled === true,
          is_new_user_onboarding:
            permissionsData.is_new_user_onboarding === true,
        };
      }
    } catch (permissionsError) {
      console.error(
        "Error fetching current user permissions:",
        permissionsError,
      );
    }

    return {
      ...data,
      sidebar_components: [],
      is_transfer_enabled: false,
      is_post_issuance_verification_enabled: false,
      is_white_label_enabled: false,
      is_html_designs_enabled: false,
      is_new_user_onboarding: false,
    };
  } catch (error) {
    console.error("Error fetching current user data:", error);
    return null;
  }
};
